// extracted by mini-css-extract-plugin
export default {"container":"styles_container__3zqL2","subtitle":"styles_subtitle__OCI+J","form":"styles_form__qO3yH","btnWrapper":"styles_btnWrapper__DBiOc"};